var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { roomService } from "../../modules/room/RoomService";
import { busService } from "../../modules/bus/BusService";
import { RoomChangedMessage, SessionMemberListMessage } from "flavr-common";
import { create } from "zustand";
import { modelPool } from "@modules/model";
export const useLocallyAvailableRoomsStore = create((set) => ({
    locallyAvailableRooms: [],
    setLocallyAvailableRooms: (locallyAvailableRooms) => {
        set({ locallyAvailableRooms });
    }
}));
export const useRoomsParticipantStore = create((set) => ({
    roomsParticipantList: [],
    setRoomsParticipantList: (roomsParticipantList) => {
        set({ roomsParticipantList });
    }
}));
function handleSessionMemberListMessage(msg) {
    // only update the room member info if the session name matches the current session
    if (msg.sessionName === localStorage.getItem("session")) {
        const roomsParticipant = [];
        msg.members.forEach((member) => {
            roomsParticipant.push(member);
        });
        useRoomsParticipantStore.getState().setRoomsParticipantList(roomsParticipant);
    }
}
function initSessionRoomsStore() {
    return __awaiter(this, void 0, void 0, function* () {
        const sendUpdate = () => {
            if (busService.connection("SessionRoomsStore").isReady()) {
                busService.connection("SessionRoomsStore").subscribeByType(RoomChangedMessage, (_msg) => {
                    useLocallyAvailableRoomsStore.getState().setLocallyAvailableRooms([]);
                    updateLocallyReachableSubRooms()
                        .then(() => { })
                        .catch((error) => {
                        console.error("[ui]", error);
                    });
                });
                busService.connection("SessionRoomsStore").subscribeByType(SessionMemberListMessage, handleSessionMemberListMessage);
            }
            else {
                setTimeout(sendUpdate, 100);
            }
        };
        sendUpdate();
    });
}
function updateLocallyReachableSubRooms() {
    return __awaiter(this, void 0, void 0, function* () {
        const roomModelUIDs = yield roomService.getSubRoomsOfCurrentRoom();
        if (roomModelUIDs !== undefined) {
            useLocallyAvailableRoomsStore.getState().setLocallyAvailableRooms(roomModelUIDs.map((modelUID) => ({
                roomUid: modelUID,
                roomName: modelPool.getModelOrThrow(modelUID).getName()
            })));
        }
    });
}
initSessionRoomsStore()
    .then(() => __awaiter(void 0, void 0, void 0, function* () {
    yield updateLocallyReachableSubRooms();
}))
    .catch((error) => {
    console.error("[ui] Error initializing session rooms store:", error);
});
